const state = {
	headerColor: '#144835',
    titleColor: 'white--text',
    buttonText: 'white--text hidden-sm-and-down text-none caption'
};

const getters = {
	headerColor: (state) => state.headerColor,
    titleColor: (state) => state.titleColor,
    buttonText: (state) => state.buttonText,
};

const actions = {
	async changeHeaderColor({commit}, color) {
		commit('updateHeaderColor', color)
	},
    async changeTitleColor({commit}, color) {
		commit('updateTitleColor', color)
	},
    async changeButtonColor({commit}, color) {
		commit('updateButtonColor', color)
	},
};

const mutations = {
	updateHeaderColor : (state, headerColor) => state.headerColor = headerColor,
    updateTitleColor : (state, titleColor) => state.titleColor = titleColor,
    updateButtonColor : (state, buttonText) => state.buttonText = buttonText,
};

export default {
	state,
	getters,
	actions,
	mutations
}